"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Level3StateDTO = void 0;
const enums_1 = require("../enums");
class Level3StateDTO {
    constructor() {
        this.canSubmit = false;
        // is the level in a disabled state
        this.disabled = false;
        // the organisms that are yet to be placed in a tile
        this.notPlaced = [];
        // the current status of the level.
        this.status = enums_1.LevelStatus.START;
        // the tile connections (filled and not filled)
        this.tileConnections = [];
        // the tiles (empty and filled)
        this.tiles = [];
        // if a submission has been recorded
        this.submitted = false;
    }
}
exports.Level3StateDTO = Level3StateDTO;
//# sourceMappingURL=Level3StateDTO.js.map